export default __webpack_public_path__ + "static/media/tour-2.8a965bdc.jpg";